<template>
<div>
  Loading
</div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { login } from '../lib/ad.azure.auth';
const { mapActions, mapMutations } =
  createNamespacedHelpers("users");

export default {
  props: ["chart"],
  data: function() {
    return {};
  },
  components: {
  },
  methods: {
    ...mapActions(["aSignIn"]),
    ...mapMutations(["mPurgeAuth"]),
    signIn(payload) {
      let progress = this.$Progress;
      let router = this.$router;
      const signIn = this.aSignIn;
      let $this = this;
      progress.start();
      signIn(payload)
        .then(function () {
          progress.finish();
          router.push({ name: "projects-home" });
        })
        .catch(function () {
          progress.finish();
          $this.error = true;
        });
    },
  },
  computed: {},
  mounted: function() {
    // localStorage.removeItem('azure_id_token');
    // localStorage.removeItem('azure_expires_at');
    // localStorage.removeItem('azure_profile');
    const token = localStorage.getItem('azure_id_token');
    if (token) {
      const payload = { token, provider: 'azure' };
      this.signIn(payload);
      // loging with azure token
    } else {
      login();
    }
    // console.log("chart.list", thchart.list);
  },
  beforeDestroy() {}
};
</script>
